import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class ArchivosService {
  constructor(private api: CloudFunctionsApiService) {}

  getArchivos(uid) {
    return this.api.snapshotList(`/files?userId=${encodeURIComponent(uid)}`);
  }

  getGroupArchivos(uid) {
    return this.api.snapshotList(`/files?classId=${encodeURIComponent(uid)}`);
  }

  getGroupCompartidosArchivos(uid) {
    return this.api.snapshotList(`/files?sharedWith=${encodeURIComponent(uid)}`);
  }

  getArchivobyId(uid) {
    return this.api.documentChange(`/files/${uid}`);
  }

  createdArchivo(archivo) {
    return this.api.post('/files', archivo).toPromise();
  }

  editArchivo(id, archivo) {
    return this.api.patch(`/files/${id}`, archivo).toPromise();
  }

  getArchivoparents(uid) {
    return this.api.snapshotList(`/files?parentId=${encodeURIComponent(uid)}`);
  }

  deletefile(id) {
    return this.api.delete(`/files/${id}`).toPromise();
  }
}
